var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content-box"},[_c('h1',[_vm._v(_vm._s(_vm.content.title))]),_c('article',{staticClass:"mt-4",domProps:{"innerHTML":_vm._s(_vm.content.detail)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }